import { tooManyRequests, unauthorized, failure } from '../types/api';
import { InsertToLocalStorage } from '../utility/localStorage';
import { UnauthorizedErrorKey } from '../types/localStorage';
import { InactivityErrorMessage } from '../types/errorMessage';

const apiUrl = import.meta.env.VITE_API_URL;

async function apiPost(endpoint: string, params?: any) {
  try {
    let requestHeaders = { 'Content-Type': 'application/json' };

    if (sessionStorage.getItem('SessionToken') != null) {
      Object.assign(requestHeaders, { 'X-Session-Token': sessionStorage.getItem('SessionToken') });
    }

    let body = {};
    if (params != null) {
      Object.assign(body, params);
    }

    const res = await fetch(apiUrl + '/' + endpoint, {
      headers: requestHeaders,
      body: JSON.stringify(body),
      method: 'POST',
    });
    if (res.status === 204) return '';
    else if (res.status === 200) {
      const data = await res.json();

      return data;
    } else if (res.status === 429) {
      return tooManyRequests;
    } else if (res.status === 401) {
      sessionStorage.removeItem('SessionToken');
      sessionStorage.removeItem('User');
      InsertToLocalStorage(UnauthorizedErrorKey, InactivityErrorMessage);
      window.location.href = '/login';
      return unauthorized;
    } else if (res.status >= 400 && res.status < 500) return failure;
    else if (res.status >= 500 && res.status < 600) return failure;
    else throw new Error('not implemented');
  } catch (exc) {
    console.log(exc);
    throw failure;
  }
}

const apiFunctions = {
  apiPost,
};

export default apiFunctions;
